import { createNullableProvideInject } from '@collector/shared-ui'

import { HistoryIncidentsConfig } from '../configuration'

export const [provideHistoryIncidentsConfig, injectHistoryIncidentsConfig] =
  createNullableProvideInject<HistoryIncidentsConfig>('historyIncidentsConfig')
